<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 22">
		<path
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="2"
			d="M19.083 20.75V3.417c0-1.197-.97-2.167-2.166-2.167H6.083c-1.196 0-2.166.97-2.166 2.167V20.75m15.166 0h2.167m-2.167 0h-5.416m-9.75 0H1.75m2.167 0h5.416m4.334 0v-5.417c0-.598-.485-1.083-1.084-1.083h-2.166c-.599 0-1.084.485-1.084 1.083v5.417m4.334 0H9.333M8.25 5.583h1.083M8.25 9.917h1.083m4.334-4.334h1.083m-1.083 4.334h1.083"
		/>
	</svg>
</template>
